import { number } from 'prop-types';
import React, { useContext, useState } from 'react';
import { callApiWithAuthorization } from '../../API/CallApi';
import EntityRecommendationContext from '../../Context/EntityRecommendation/EntityRecommendationContext';

function useImportSelectedRecommendationData(organizationId, projectId) {

    const { api, state } = useContext(EntityRecommendationContext);

    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);

    async function importData() {
        debugger;
        const selectedEntities = getSelectedEntities();
        const selectedRelations = getSelectedRelations();
        try {
            const request = await callApiWithAuthorization("/api/v0/recommend/import", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    organizationId,
                    projectId,
                    selectedEntities,
                    selectedRelations
                })
            });
            const response = await request.json();
            setResponse(response);
        } catch (e) {
            setError(e);
        }
    }
    
    function getSelectedEntities() {
        return state.data.filter(entity => entity.selected).map(entity => {
            const { selected, expanded, attributes, id, name } = entity;
            return {
                name,
                entityId: id,
                attributes: attributes.filter(attribute => attribute.selected).map(attribute => {
                    const { selected, id, attributeName  } = attribute;
                    return {
                        attributeName,
                        attributeId: id
                    };
                })
            };
        });
    }

    function getSelectedRelations() {
        return state.relations.filter(relation => relation.selected).map(relation => {
            const { selected, id, ...properties } = relation;
            return properties; 
        });
    }

    return { importData, response, error };
}

export default useImportSelectedRecommendationData;